export const getExtension: (filename: string) => string = (filename) => {
  try {
    const ext: string | undefined = filename.split(".").pop();
    return ext == undefined || ext == null ? '' : ext;
  }
  catch {
    return '';
  }
}

export const parseFixedFloat: (aNumber: string, presition: number) => number = (aNumber, presition) => {
  return parseFloat(parseFloat(aNumber).toFixed(presition));
}